<div
    class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto"
    cdkScrollable>

    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">

        <!-- CONTENT GOES HERE -->
        <div class="h-400 min-h-400 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl"></div>

    </div>

</div>
